<template>
  <div id="eventTrackingErrorsDetailPage">
    <!-- Page Header -->
    <div class="pageHeader">
      <div class="headerContent">
        <div>
          <a @click="goBack()" style="cursor: pointer; margin-right: 10px">
            <i class="el-icon-back"></i>
          </a>
          <span v-if="eventName" class="pageTitle">Event Sync Errors: {{ eventName }}</span>
          <span v-else class="pageTitle">All Events</span>
          <!-- Total Count -->
          <div v-if="errorDetails" class="totalCount pl-8">
            Total Errors: <strong>{{ getNumberWithComma(errorDetails.totalCount) }}</strong>
          </div>
        </div>
        <div>
          <el-select v-model="timingFilter" size="small" class="w-48">
            <el-option-group v-for="group in eventTrackingErrorsTimingOptions" :key="group.label" :label="group.label">
              <el-option v-for="item in group.options" :key="item.value" :label="item.title" :value="item.value"> </el-option>
            </el-option-group>
          </el-select>
          <el-date-picker class="w-20 mt-2" size="small" :editable="false" start-placeholder="Start Date" end-placeholder="End Date" :clearable="false" v-if="timingFilter == 'custom'" v-model="customTimeRange" type="daterange" format="dd-MMM-yyyy" @change="onDateRangeChange"> </el-date-picker>
          <div v-if="displayTimeRange && timingFilter != 'custom' && !fetchingData" class="text-right text-xs text-gray-400 py-1">
            {{ displayTimeRange.start + ' - ' + displayTimeRange.end }}
          </div>
        </div>
      </div>
    </div>

    <!-- Error Trend Chart Card -->
    <el-card class="chartCard" shadow="never" v-loading="fetchingData">
      <div slot="header" class="chartHeader">
        <span>Error Trend (Daily)</span>
      </div>
      <div v-if="!fetchingData && chartOptions">
        <highcharts :options="chartOptions"></highcharts>
      </div>
      <div v-else-if="!fetchingData" class="noDataDiv">
        <i class="fa fa-bar-chart"></i>
        <div>No error data available for the selected date range</div>
      </div>
    </el-card>

    <!-- Error Details Table Card -->
    <el-card class="tableCard" shadow="never" v-loading="fetchingData">
      <div slot="header" class="tableHeader">
        <span>Error Details</span>
      </div>
      <el-table v-if="!fetchingData && errorDetails && errorDetails.rows" :data="errorDetails.rows" style="width: 100%" @row-click="onErrorRowClick">
        <el-table-column prop="created_at_date" label="Timestamp" width="220" class-name="timestamp-column">
          <template slot-scope="scope">
            <!-- <span class="timestamp-text">{{ formatDateTime(scope.row.formatted_timestamp || scope.row.created_at_date) }}</span> -->
            <span class="timestamp-text">{{ formatDateTime(scope.row.created_at_date.value) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="event_category" label="Event Category" max-width="50">
          <template slot-scope="scope">
            {{ scope.row.event_category || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="error_message" label="Error Message" min-width="300">
          <template slot-scope="scope">
            <span class="errorMessage">{{ getErrorMessage(scope.row) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-else-if="!fetchingData" class="noDataDiv">
        <i class="fa fa-table"></i>
        <div>No error details available</div>
      </div>

      <!-- Pagination -->
      <div class="paginationContainer" v-if="!fetchingData && errorDetails && errorDetails.totalCount > 0">
        <el-pagination @current-change="onPageChange" :current-page="currentPage" :page-size="pageSize" :total="errorDetails.totalCount" layout="total, prev, pager, next"> </el-pagination>
      </div>
    </el-card>

    <!-- Raw Data Modal -->
    <el-dialog title="Error Details" :visible.sync="showRawDataModal" width="70%" :before-close="closeRawDataModal" :body-style="{ padding: '0' }">
      <div v-if="selectedError" class="rawDataContainer">
        <el-tabs type="border-card" v-model="activeErrorTab">
          <el-tab-pane label="Error Output" name="errorOutput">
            <tree-view v-if="getErrorDetailsForTreeView(selectedError.error_details)" :data="getErrorDetailsForTreeView(selectedError.error_details)" :options="{ maxDepth: 4, rootObjectKey: 'Error Details' }"></tree-view>
            <pre v-else class="jsonContent">{{ formatJson(selectedError.error_details || selectedError.error_output) }}</pre>
          </el-tab-pane>
          <el-tab-pane label="Input Payload" name="inputPayload">
            <tree-view v-if="getJsonValueIfAvailable(selectedError.input_payload)" :data="getJsonValueIfAvailable(selectedError.input_payload)" :options="{ maxDepth: 4, rootObjectKey: 'Input Payload' }"></tree-view>
            <pre v-else class="jsonContent">{{ formatJson(selectedError.input_payload) }}</pre>
          </el-tab-pane>
          <el-tab-pane label="Full Error Data" name="fullData">
            <tree-view v-if="formatFullErrorData(selectedError)" :data="formatFullErrorData(selectedError)" :options="{ maxDepth: 4, rootObjectKey: 'Full Error Data' }"></tree-view>
            <pre v-else class="jsonContent">{{ formatJson(selectedError) }}</pre>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copyToClipboard()"> <i class="fa fa-copy"></i> Copy to Clipboard </el-button>
        <el-button @click="showRawDataModal = false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" src="./eventTrackingErrorsDetail.scss"></style>

<script>
import eventTrackingErrorsDetailComponent from './eventTrackingErrorsDetailComponent';
export default eventTrackingErrorsDetailComponent;
</script>
